export function colToLabel(col) {
    let name = "";
    for (let n = col; n >= 0; n = Math.floor(n / 26) - 1)
        name = String.fromCharCode(65 + (n % 26)) + name;
    return name;
}
export function labelToCol(label) {
    let n = 0;
    for (const ch of label.toUpperCase())
        n = n * 26 + (ch.charCodeAt(0) - 64);
    return n - 1;
}
export function cellKey(col, row) {
    return `${colToLabel(col)}${row + 1}`;
}
export function cellRefText(addr) {
    return `${addr.colAbs ? "$" : ""}${colToLabel(addr.col)}${addr.rowAbs ? "$" : ""}${addr.row + 1}`;
}
const BARE_SHEET_NAME = /^[A-Za-z_][A-Za-z0-9_]*$/;
export function formatSheetName(name) {
    if (BARE_SHEET_NAME.test(name))
        return name;
    return `'${name.replace(/'/g, "''")}'`;
}
export function sheetRefPrefix(name) {
    return `${formatSheetName(name)}!`;
}
export function sheetNamesEqual(a, b) {
    return a.toLowerCase() === b.toLowerCase();
}
export function parseCellKey(key) {
    let i = 0;
    while (i < key.length && key[i] >= "A" && key[i] <= "Z")
        i++;
    return { col: labelToCol(key.slice(0, i)), row: Number(key.slice(i)) - 1 };
}
export function usedExtent(cells) {
    let rows = 0;
    let cols = 0;
    for (const key of Object.keys(cells)) {
        const { col, row } = parseCellKey(key);
        if (row + 1 > rows)
            rows = row + 1;
        if (col + 1 > cols)
            cols = col + 1;
    }
    return { rows, cols };
}
//# sourceMappingURL=addr.js.map